import {
	formatAsDayAndMonth,
	formatAsShortDate,
} from "../../core/helpers/date-formatting-util.js";
import Period from "./Period.js";

/**
 * `Day` is a period representing day.
 * Instances should not be created by hand, but rather looked up
 * from `fiscalYear`.
 *
 * @param {{}} spec - Parameter object
 * @param {{}} my - protected fields holder
 * @return {*} day
 */
export default class Day extends Period {
	constructor(spec) {
		super(spec);
		this._name = formatAsDayAndMonth(this._start);
		this._periodId = this._name;
	}

	toSmartString() {
		return formatAsShortDate(this._start);
	}

	static getType() {
		return "Day";
	}
}
